module.exports = __webpack_public_path__ + "static/media/grosser_heidegrashuepfer_gesang.bbc77428.mp3";